import config from '../../../../constants/Configs';
import Utils from '../../../../services/Utils';
export const CashierEnum = {
    Deposit: 0,
    Withdrawal: 1,
    Transaction: 2,
    Tournaments: 3,
    IframeSettings: 4,
    Both: 5,
}
export const PaymentRequestStates = config.NEW_PLAT ? {
    Pending: 1,
    InProcess: 2,
    CanceledByUser: 3,
    CancelledByPlayer :4,
    Failed: 5,
    Declined :7,
    Frozen: 8,
    PayPending :9,
    Paid : 10
    
} : {
    Pending: 1,
    CanceledByClient: 2,
    InProcess: 3,
    Frozen: 4,
    WaitingForKYC: 5,
    CanceledByUser: 6,
    Allowed: 7,
    Approved: 8,
    Failed: 9,
    PayPanding: 10,
    Answered: 11,
    CancelApproved: 12,
    CanceledByPayment: 13,
    WaitingForPayment: 14,
    CheckName: 15,
    AllowedName: 16,
    P2PAllowed: 17,
    P2PCanceled: 18,
    CartiPayAllowed: 19,
    C2CAllowed: 20,
    FirstTimeDeposit: 100,
    FirstTimeWithdraw: 101
}
export const OperationTypeEnum = {
    GeneralBet : 1,
    GeneralWin : 2,
    InGameGiftBet: 4,
    InGameGiftWin : 5,
    RoundFinish : 6,
    InsuranceBet : 7,
    InsuranceWin : 8,
    DoubleBet : 9,
    DoubleWin : 10,
    SplitBet : 11,
    SplitWin : 12,
    AnteBet : 13,
    AnteWin : 14,
    GeneralBetBehind : 15,
    GeneralWinBehind : 16,
    SplitBetBehind : 17,
    SplitWinBehind : 18,
    DoubleBetBehind : 19,
    DoubleWinBehind : 20,
    InsuranceBetBehind : 21,
    InsuranceWinBehind  : 22,
    CallBet : 23,
    CallWin : 24,
    JackpotWin : 26,
    Tip : 27,
    GiftBet : 30,
    GiftWin : 31,
    Fee : 34,
    WinTournament : 35,
    AmendCredit : 37,
    AmendDebit : 38,
    GameDataChangeBet : 42,
    GameDataChangeWin : 43,
    TakeRiskBet : 45,
    TakeRiskWin : 46,
    CardsCombinationBet : 48,
    CardsCombinationWin : 49,
    DiceCombinationBet : 51,
    DiceCombinationWin : 52,
    MagicCardBet : 54,
    MagicCardWin : 55,
    DoublingBet : 57,
    DoublingWin : 58,
    ShopBet : 60,
    ShopWin : 61,
    TournamentKingBet : 67,
    TournamentKingWin : 68,
    DropBet : 71,
    DropWin : 72,
    BetRakeRaceTournament : 73,
    WinRakeRaceTournament: 74,
    CashBack : 75,
    CashOut : 500,
    DecreaseCashOut : 501,
    DecreaseCashBack : 502,
    ExpressBonus : 503,
    DecreaseExpressBonus : 504,
    Cancelled : 505,
    CancelWin : 506,
    WinRecalculateIncrease : 507,
    WinRecalculateDecrease : 508,
    BonusBet : 509,
    BonusWin : 510,
    BonusWinIncrease : 511,
    BonusWinDecrease : 512,
    CancelBetBuyIn : 513,
    CancelWinPayout : 514,
    TaxOnBetProfitDecrease : 520,
    TaxOnBetProfitIncrease : 521,
    CashbackCorrectionIncrease : 1001,
    ReferralCommission : 1002,
    CommissionCorrectionIncrease : 1003,
    TournamentPrize : 1004,
    PrizeCorrectionIncrease : 1005,
    RedeemBonus : 1006,
    BonusRedeemCorrectionIncrease : 1007,
    Jackpot : 1008,
    JackpotCorrectionIncrease : 1009,
    GeneralCorrectionIncrease : 1010,
    RealMoneyBonus : 1011,
    FundsCleared  : 1051,
    CashbackCorrectionDecrease : 1052,
    CommissionCorrectionDecrease : 1053,
    PrizeCorrectionDecrease : 1054,
    JackpotCorrectionDecrease : 1055,
    BonusRedeemCorrectionDecrease : 1056,
    GeneralCorrectionDecrease : 1057,
    ActivateBonus : 1100,
    BonusCorrectionIncrease : 1101,
    RedirectDepositIncrease : 1102,
    CancelBonusRedeem : 1150,
    BonusCorrectionDecrease : 1151,
    RedirectDepositDecrease : 1153,
    CancelBonus : 1154,
    BonusExpired : 1155,
    CancelBonusBet: 1156,
    Deposit : 2001,
    Withdrawal : 2051,
    DepositFee : 2052,
    WithdrawalFee : 2053,
    RedirectedDepositFee : 2054,
    CancelFee  : 2056,
    DepositCorrectionIncrease : 2567,
    WithdrawalCorrectionDecrease : 2568,
    WithdrawalCorrectionIncrease : 2569,
    DepositCorrectionDecrease : 2570,
    WithdrawalFromUsedWallet : 2571,
    WithdrawalFromUnusedWallet : 2572,
    WithdrawalFeeFromUsedWallet : 2573,
    WithdrawalFeeFromUnusedWallet : 2574,
    WithdrawalCancel : 2575,
    BalanceAdjustmentClearFunds : 2576,
    BuyActivation: 2701
}
export const TransactionTypesEnum = config.NEW_PLAT ? Object.keys(OperationTypeEnum).reduce((ret, key) => {ret[OperationTypeEnum[key]] = Utils.toCamelCase(key);return ret;}, {})  : {
    1: 'debit',
    2: 'credit'
}
export const CashierWithdrawalsType = {
    StandardPayment: 1,
    VoucherPayments: 2,
    TwoStepWithdrawals: 3
}

export const  WalletTypeEnum ={
Rollover :1,
Unused:2,
Used:3,
Bonus:4,
Booking : 5,
SportBonus : 90,
FreeBet : 101,
WagerStandard : 102,
WagerReal : 103
}

Object.freeze(CashierEnum);

export default CashierEnum;

export const  TransactionsHistoryTypeEnum ={
    BalanceAdjustment: 0,
    ReferrerHistory: 1,
    Cashback: 2,
    SportJackpot: 3,
    Bonuses: 4,
    BuyActivation: 5,
    CasinoJackpot: 6,
    CasinoTax:7
 }